export const CLASS_NAMES = {
    CONTAINER: "js-dialog",
    TRIGGER: "js-dialogTrigger",
    CLOSE_BUTTON: "js-dialogClose"
};
